import { useMutation } from '@tanstack/react-query';
import { useDispatch } from 'react-redux';
import detachCredits from '../../api/credits/detach-credits';
import { getCart } from '../../reducers/cart';

const useDetachCredits = () => {
    const dispatch = useDispatch();

    return useMutation({
        mutationFn: detachCredits,
        // TODO FE-249 Stage 2: swap for refetchCart(queryClient) once the cart moves to React Query
        onSuccess: () => new Promise<void>((resolve) => dispatch(getCart(resolve)))
    });
};

export default useDetachCredits;
